import React from 'react';
import cn from 'classnames';
import AgreementCheckbox from './AgreementCheckbox/AgreementCheckbox';
import { useAgreementCheckboxWrapper } from './AgreementCheckboxWrapper.hook';
import { useTheme, useMergeClasses } from '../../theme';
const AgreementCheckboxWrapper = ({ className, classes, showTooltip, children, checkboxes: initialCheckboxes, renderButton }) => {
    const { AgreementCheckboxWrapper: defaultClasses } = useTheme('AgreementCheckboxWrapper');
    const css = useMergeClasses(defaultClasses, classes);
    const { checkboxesRef, isValid, checkedCheckboxes, onChange, scrollToCheckboxes } = useAgreementCheckboxWrapper(initialCheckboxes);
    return (React.createElement(React.Fragment, null,
        children({ isValid, scrollToCheckboxes }),
        React.createElement("div", { className: css.footer_wrapper },
            React.createElement("div", { className: cn(css.checkboxes_wrapper, className), ref: checkboxesRef }, !!checkedCheckboxes.length &&
                checkedCheckboxes.map(item => (React.createElement(AgreementCheckbox, Object.assign({ key: item.fieldName }, item, { showTooltip: showTooltip, onChange: onChange }))))),
            !!renderButton && renderButton({ isValid, scrollToCheckboxes }))));
};
export default AgreementCheckboxWrapper;
